import React from 'react'


export default function RepresentativesInfo() {
    return (
        <div className="representativesInfo">
            <h1 className="homeTitle">Representantes</h1>
            <h2 className="homeText">A Rasil Borrachas tem representantes em vários estados do Brasil para atender diversas  demandas. Confira os contatos de cada representante abaixo:</h2>          
        </div>             

    );
}